import socketClient from './socket-client';

const baseURLSocket = process.env.REACT_APP_BASE_API_WS;

socketClient.connect(baseURLSocket, {path: process.env.NODE_ENV !== 'production' ? '' : '/socket.io/'});
socketClient.requestInterceptor = (request, type) => {
    request.headers.authorization = `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)}`;
    return request;
};

// const observerUserNotifications = socketClient.subscribe('USER_NOTIFICATIONS');


export {socketClient}
